import { green, orange, red, blue, gray } from '@ant-design/colors';
import { Card, Col, Progress, Row } from 'antd';
import { FC, useMemo } from 'react';

import { calculateHealthPercentage } from '../utils';
import { useHeroStore } from '../store/game.store';


interface HeroCardProps extends React.PropsWithChildren {
   imageFilePath: string;
   name: string;
}

export const HeroCard: FC<HeroCardProps> = ({ imageFilePath, name }) => {

   const { state } = useHeroStore();
   const { armor, currentGuardAmount, currentHealth, maxHealth } = state;
   const healthPercentage = useMemo(() => calculateHealthPercentage({ currentHealth: currentHealth, maxHealth: maxHealth }), [currentHealth, maxHealth]);

   const progressColour = useMemo(() => {
      switch (true) {
         case healthPercentage > 90:
            return green[5];
         case healthPercentage > 75:
            return green[3];
         case healthPercentage > 50:
            return orange[5];
         case healthPercentage > 25:
            return red[3];
         default:
            return red[5];
      }
   }, [healthPercentage]);


   return (

      <div className='heroBorder p-1 width30percent whiteBG'>


         <Card
            hoverable
            cover={
               <img
                  src={imageFilePath}
                  alt={name}
                  className="h-16 object-scale-down"
               />
            }
            className="max-w-xs"
         >
         </Card>


         <Row >
            <Col span={20}>
               <Progress
                  percent={healthPercentage}
                  strokeColor={progressColour}
                  showInfo={false}
               />
            </Col>

            {armor > 0 && (
               <Col span={2}>
                  <Progress
                     percent={(armor / 3 * 100)}
                     strokeColor={gray[5]}
                     showInfo={false}
                  />


               </Col>
            )}

            {currentGuardAmount > 0 && (
               <Col span={2}>
                  <Progress
                     percent={100}
                     strokeColor={blue[5]}
                     showInfo={false}
                  />
               </Col>
            )}

         </Row>

         <p>Health: {currentHealth}/{maxHealth}</p>
      </div>

   );
};
